// extracted by mini-css-extract-plugin
export default {"create-content-link":"ProjectCollectionCreation_create-content-link__rtR5O","project-image":"ProjectCollectionCreation_project-image__Z6G+U"};